import { useState, useEffect } from 'react';
import { Brain, ChevronDown, ChevronUp } from 'lucide-react';
import ModuleContainer from '../layout/ModuleContainer.jsx';

export default function MnemosyneStats() {
  const [stats, setStats] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch('/api/mnemosyne/stats');
        if (res.ok) setStats(await res.json());
      } catch { /* silent */ }
    }
    load();
    const interval = setInterval(load, 300000); // every 5 min
    return () => clearInterval(interval);
  }, []);

  return (
    <ModuleContainer
      title={
        <button onClick={() => setExpanded(!expanded)} className="flex items-center gap-2 w-full text-left">
          {expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
          <Brain className="w-3 h-3 text-purple-400" />
          <span>Mnemosyne — KAIROS Memory</span>
          {stats && <span className="text-[9px] font-mono text-purple-400 ml-2">{stats.total} memories</span>}
        </button>
      }
    >
      {expanded && stats ? (
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-2">
            {(stats.byWing || []).map(w => (
              <div key={w.wing} className="bg-korinth-bg rounded px-2 py-1.5 text-center">
                <div className="text-sm font-mono font-bold text-purple-400">{w.cnt}</div>
                <div className="text-[8px] text-korinth-muted">{w.wing}</div>
              </div>
            ))}
          </div>

          {stats.recent?.length > 0 && (
            <div>
              <h4 className="text-[9px] font-mono text-korinth-muted uppercase tracking-wider mb-1">Recent Additions</h4>
              <div className="space-y-1 max-h-32 overflow-y-auto">
                {stats.recent.map((m, i) => (
                  <div key={m.id || i} className="text-[10px] font-mono text-korinth-text px-2 py-1 bg-korinth-bg rounded">
                    <span className="text-purple-400">[{m.wing}/{m.room}]</span> {m.content?.slice(0, 80)}...
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="text-[10px] font-mono text-korinth-muted">
          {stats ? `${stats.total} memories across ${(stats.byWing || []).length} categories` : 'Loading...'} — click to expand
        </div>
      )}
    </ModuleContainer>
  );
}
